import { AUTH, COMMON } from '@/constants'
import { Api, TokenApi } from '@/utils/api'

// Get User with Token
export const getCurrentUser = () => {
  return async (dispatch) => {
    try {
      const res = {status: 'success', data: {profile: {address1: null,
        address2
        : 
        null,
        birthday
        : 
        null,
        city
        : 
        null,
        country
        : 
        null,
        disability
        : 
        null,
        email
        : 
        "mit.shah@creolestudios.com",
        first_name
        : 
        "Mit",
        gender
        : 
        null,
        github_url
        : 
        null,
        id
        : 
        3,
        is_active
        : 
        true,
        last_name
        : 
        "Shah",
        lgbtq
        : 
        null,
        linkedln_url
        : 
        null,
        phone_code
        : 
        null,
        phone_number
        : 
        null,
        race
        : 
        null,
        resume
        : 
        null,
        resume_uploaded
        : 
        null,
        skills
        : 
        "",
        state
        : 
        null,
        twitter_url
        : 
        null,
        user
        : 
        3,
        veteran
        : 
        null,
        website_url
        : 
        null,
        zip_code
        : 
        null}, education: Array(0), work_experience: Array(0)}}
      return res
    } catch (err) {
      dispatch(logOut())
    }
  }
}

// Login
export const login = (obj) => (dispatch) =>
  Api.post('login/', obj)
    .then((res) => {
      window.localStorage.setItem('accessToken', res.access)
      window.localStorage.setItem('refreshToken', res.refresh)
      return res
    })
    .catch((err) => {
      dispatch({
        type: COMMON.TOP_ALERT,
        payload: { type: 'error', message: err.errors[0]['message'] }
      })
      throw err
    })

// Logout
export const logOut = () => (dispatch) => {
  window.localStorage.removeItem('accessToken')
  window.localStorage.removeItem('refreshToken')

  dispatch({
    type: AUTH.SIGNED_OUT
  })
}

// Signup
export const signup = (obj) => {
  return async (dispatch) => {
    try {
      const res = await AI.post('register', obj)
      return res
    } catch (err) {
      throw err
    }
  }
}

export const updateProfile = async (data, pk) => {
  try {
    const res = await AI.put(`profile/${pk}`, data)
    return res
  } catch (err) {
    throw err
  }
}

export const createOrUpdateWorkExperience = async (data, pk = null) => {
  try {
    let res = null
    if (pk) res = await AI.put(`work-experience/${pk}`, data)
    else res = await AI.post(`work-experience`, data)
    return res
  } catch (err) {
    throw err
  }
}

export const deleteWorkExperience = async (id) => {
  try {
    await AI.delete(`work-experience/${id}`)
  } catch (err) {
    throw err
  }
}

export const createOrUpdateEducation = async (data, pk = null) => {
  try {
    let res = null
    if (pk) res = await AI.put(`education/${pk}`, data)
    else res = await AI.post(`education`, data)
    return res
  } catch (err) {
    throw err
  }
}

export const deleteEducation = async (id) => {
  try {
    await AI.delete(`education/${id}`)
  } catch (err) {
    throw err
  }
}
